import { render, staticRenderFns } from "./SwipeModal.vue?vue&type=template&id=0a4647ca&scoped=true"
import script from "./SwipeModal.vue?vue&type=script&lang=js"
export * from "./SwipeModal.vue?vue&type=script&lang=js"
import style0 from "./SwipeModal.vue?vue&type=style&index=0&id=0a4647ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4647ca",
  null
  
)

export default component.exports